import { BASE_DOMAIN } from './shopeeDomains.mjs';
import { cid } from './env.mjs';

/* shopee app download or upgrade url */
const IOS_APP_ID_ALL = {
    sg: '959840394',
    my: '959841113',
    th: '959841453',
    tw: '959841107',
    vn: '959841449',
    id: '959841443',
    ph: '959841854',
    br: '1481812175',
    mx: '1540749085',
    co: '1554257433',
    cl: '1554257918',
};
const IOS_APP_ID = IOS_APP_ID_ALL[cid];
const ANDROID_APP_PKG_ALL = {
    sg: 'com.shopee.sg',
    my: 'com.shopee.my',
    th: 'com.shopee.th',
    tw: 'com.shopee.tw',
    vn: 'com.shopee.vn',
    id: 'com.shopee.id',
    ph: 'com.shopee.ph',
    br: 'com.shopee.br',
    mx: 'com.shopee.mx',
    co: 'com.shopee.co',
    cl: 'com.shopee.cl',
};
const ANDROID_APP_PKG = ANDROID_APP_PKG_ALL[cid];
const shopeeAppUpgradeUrl = `${BASE_DOMAIN}/download/`;

export { ANDROID_APP_PKG, ANDROID_APP_PKG_ALL, IOS_APP_ID, IOS_APP_ID_ALL, shopeeAppUpgradeUrl as default };
